/**
 * Utility function to safely extract error messages from unknown error types
 * @param error - The error to extract a message from
 * @returns A user-friendly error message string
 */
export const getErrorMessage = (error: unknown) => {
    if (error instanceof Error) {
        return error.message || 'An error occurred';
    }
    
    if (typeof error === 'string') {
        return error;
    }
    
    if (error && typeof error === 'object' && 'message' in error) {
        return String(error.message);
    }
    
    return 'An unexpected error occurred';
};

/**
 * Utility function to safely extract error messages with custom fallback
 * @param error - The error to extract a message from
 * @param fallback - Custom fallback message if no message can be extracted
 * @returns A user-friendly error message string
 */
export const getErrorMessageWithFallback = (error: unknown, fallback = 'An unexpected error occurred') => {
    if (error instanceof Error) {
        return error.message || fallback;
    }
    
    if (typeof error === 'string') {
        return error;
    }
    
    if (error && typeof error === 'object' && 'message' in error) {
        return String(error.message);
    }
    
    return fallback;
};